import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SHEET_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzkPwZSQaeldDclIrZFE8ojPhzARQ4ELEwaeeS5ZDl2G0yDWbu_Q1fQ4XJkHP_WHyhR/exec';

export default function ContactForm() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        companyName: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        // Check if input field is filled and add class accordingly
        const parent = e.target.parentNode;
        if (value.trim() !== '') {
            parent.classList.add('filled');
            parent.classList.remove('error');
        } else {
            parent.classList.remove('filled');
        }

    };
    const [errors, setErrors] = useState({});



    const handleFocus = (e) => {
        e.target.parentNode.classList.add('focus');
    };

    const handleBlur = (e) => {
        e.target.parentNode.classList.remove('focus');
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const errors = {};
        if (formData.firstName.trim() === '') {
            errors.firstName = 'First Name is required';
        }
        if (formData.lastName.trim() === '') {
            errors.lastName = 'Last Name is required';
        }
        if (formData.email.trim() === '') {
            errors.email = 'Email is required';
        } else if (!isValidEmail(formData.email)) {
            errors.email = 'Invalid email format';
        }
        if (formData.phoneNumber.trim() === '') {
            errors.phoneNumber = 'Phone Number is required';
        } else if (!isValidPhoneNumber(formData.phoneNumber)) {
            errors.phoneNumber = 'Invalid phone number format';
        }
        if (formData.companyName.trim() === '') {
            errors.companyName = 'Company name is required';
        }
        if (formData.subject.trim() === '') {
            errors.subject = 'Subject is required';
        }
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return;
        }

        const payload = { ...formData, sheetName: 'Contact Leads' };

        Promise.allSettled([
            fetch('https://thespinnennetz.com/sn-forms/contact.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            }),
            fetch(SHEET_ENDPOINT, {
                method: 'POST',
                mode: 'no-cors',
                headers: { 'Content-Type': 'text/plain;charset=utf-8' },
                body: JSON.stringify(payload),
            })
        ])
            .then(results => {
                console.log('Form submitted successfully', results);
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phoneNumber: '',
                    companyName: '',
                    subject: '',
                    message: ''
                });
                navigate("/thank-you-contact");
            })
            .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
    };

    const isValidPhoneNumber = (phoneNumber) => {
        // Basic phone number validation (digits only, at least 7 digits)
        const re = /^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/;
        return re.test(phoneNumber);
    };

    const isValidEmail = (email) => {
        // Basic email validation
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    return (
        <>
            <div className="form-section contact cSection">
                <div className="cContainer">
                    <div className="sn-form-outer">
                        <h3>SEND US A MESSAGE</h3>
                        <form className="sn-form-grid" onSubmit={handleSubmit} encType="multipart/form-data">
                            <div className={`sn-floating-group sn-half ${errors.firstName ? 'error' : ''} ${formData.firstName ? 'filled' : ''}`}>
                                <input type="text" name="firstName" className="sn-form-control" value={formData.firstName} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>First Name</label>
                                {errors.firstName && <span className="sn-err">{errors.firstName}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.lastName ? 'error' : ''} ${formData.lastName ? 'filled' : ''}`}>
                                <input type="text" name="lastName" className="sn-form-control" value={formData.lastName} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Last Name</label>
                                {errors.lastName && <span className="sn-err">{errors.lastName}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.email ? 'error' : ''} ${formData.email ? 'filled' : ''}`}>
                                <input type="email" name="email" className="sn-form-control" value={formData.email} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Email Address</label>
                                {errors.email && <span className="sn-err">{errors.email}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.phoneNumber ? 'error' : ''} ${formData.phoneNumber ? 'filled' : ''}`}>
                                <input type="tel" name="phoneNumber" className="sn-form-control" value={formData.phoneNumber} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Phone Number</label>
                                {errors.phoneNumber && <span className="sn-err">{errors.phoneNumber}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.companyName ? 'error' : ''} ${formData.companyName ? 'filled' : ''}`}>
                                <input type="text" name="companyName" className="sn-form-control" value={formData.companyName} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Company Name</label>
                                {errors.companyName && <span className="sn-err">{errors.companyName}</span>}
                            </div>
                            <div className={`sn-floating-group sn-half ${errors.subject ? 'error' : ''} ${formData.subject ? 'filled' : ''}`}>
                                <input type="text" name="subject" className="sn-form-control" value={formData.subject} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Subject</label>
                                {errors.subject && <span className="sn-err">{errors.subject}</span>}
                            </div>
                            <div className={`sn-floating-group sn-full ${errors.message ? 'error' : ''} ${formData.message ? 'filled' : ''}`}>
                                <textarea name="message" className="sn-form-control sn-textarea" value={formData.message} placeholder=" " onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                <label>Message</label>
                            </div>
                            <button type="submit" className="sn-submit-btn sn-full">
                                Submit <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

